// Central brand & content for Royal Tours Group — Veena-style layout
export const BRAND = {
  name: "Royal Tour & Travel India Pvt Ltd",
  shortName: "Royal Tours Group",
  tagline: "Great Holiday, Beyond Expectation",
  established: "March 2010",
  phone: "+91-7052163551",
  phoneAlt: "+91-7052163551",
  nri: "+91-7052163551",
  whatsapp: "+91-7052163551",
  email: "info@royaltoursgroup.com",
  address: "1st Floor, Shop No-23, St. Andrews College, Golghar, Gorakhpur, U.P. 273001",
  logo:
    "/assets/media/logo.png",
};

export const TOP_UTILITY = [
  { label: "Home", href: "/" },
  { label: "About us", href: "/about" },
  { label: "Contact us", href: "/contact" },
  { label: "Videos", href: "/videos" },
  { label: "eBrochure 2026", href: "/ebrochure-2026" },
];

export const NAV_LINKS = [
  {
    label: "India",
    route: "/india",
    mega: {
      kind: "destinations",
      video: {
        title: "Incredible India · 4K",
        youtubeId: "rTDaZoDDW5g",
        thumbnail: "/assets/media/032-images-unsplash-com-photo-1564507592333-c60657eea523.jpg",
      },
      feature: {
        title: "Best of Kashmir",
        subtitle: "8 Days · ₹54,000",
        image: "/assets/media/047-images-unsplash-com-photo-1675185991531-9c2aee461355.jpg",
      },
      topRow: ["Jammu and Kashmir", "Leh Ladakh", "Sikkim Darjeeling", "North East", "Kerala", "Andaman and Nicobar", "Himachal Pradesh"],
      regions: [
        {
          name: "North India",
          groups: [
            { state: "All of North India", cities: [] },
            { state: "Delhi", cities: [] },
            { state: "Himachal Pradesh", cities: ["Dalhousie", "Dharamshala", "Manali", "Shimla", "Spiti Valley"] },
            { state: "Kashmir", cities: ["Gulmarg", "Pahalgam", "Sonmarg", "Srinagar"] },
            { state: "Leh-Ladakh", cities: ["Kargil", "Leh", "Nubra Valley", "Pangong Tso"] },
            { state: "Amritsar", cities: [] },
            { state: "Chandigarh", cities: [] },
            { state: "Punjab & Haryana", cities: ["Kurukshetra", "Panipat"] },
            { state: "Uttarakhand", cities: ["Jim Corbett Park", "Haridwar", "Mussoorie", "Nainital", "Rishikesh", "Chardham Yatra"] },
            { state: "Uttar Pradesh", cities: ["Agra", "Ayodhya", "Fatehpur Sikri", "Jhansi", "Lucknow", "Mathura", "Prayagraj", "Sarnath", "Varanasi", "Vrindavan"] },
          ],
        },
        {
          name: "South India",
          groups: [
            { state: "All of South India", cities: [] },
            { state: "Andaman & Nicobar Islands", cities: ["Havelock", "Neil Island", "Port Blair"] },
            { state: "Andhra Pradesh", cities: ["Visakhapatnam (Vizag)"] },
            { state: "Telangana", cities: ["Hyderabad", "Ramoji"] },
            { state: "Karnataka", cities: ["Badami", "Bengaluru", "Belur", "Dandeli", "Chitradurga", "Gokarna", "Halebid", "Coorg", "Hampi", "Mangaluru", "Murudeshwar", "Mysore", "Shravanbelagola", "Udupi"] },
            { state: "Kerala", cities: ["Alleppey", "Athirappilly", "Bekal", "Cochin", "Guruvayur", "Kumarakom", "Munnar", "Periyar", "Thiruvananthapuram", "Varkala"] },
            { state: "Tamil Nadu", cities: ["Chennai", "Coimbatore", "Coonoor", "Kanchipuram", "Kanyakumari", "Kodaikanal", "Madurai", "Mahabalipuram", "Ooty", "Pondicherry", "Rameswaram", "Thanjavur", "Trichy"] },
          ],
        },
        {
          name: "East & North East India",
          groups: [
            { state: "All of North East", cities: [] },
            { state: "All of Sikkim Darjeeling", cities: [] },
            { state: "Arunachal Pradesh", cities: ["Bomdila", "Tawang"] },
            { state: "Assam", cities: ["Guwahati", "Silchar", "Kaziranga National Park", "Manas National Park", "Tezpur"] },
            { state: "Manipur", cities: ["Imphal"] },
            { state: "Meghalaya", cities: ["Cherrapunjee", "Dawki", "Mawlynnong", "Shillong"] },
            { state: "Mizoram", cities: ["Aizawl"] },
            { state: "Nagaland", cities: ["Kohima"] },
            { state: "Orissa", cities: ["Bhubaneshwar", "Chilika", "Konark", "Puri"] },
            { state: "Sikkim", cities: ["Gangtok", "Lachung", "Namchi", "Pelling"] },
            { state: "Tripura", cities: ["Agartala"] },
            { state: "West Bengal", cities: ["Bagdogra", "Darjeeling", "Kalimpong", "Kolkata", "Sunderbans"] },
          ],
        },
        {
          name: "Rajasthan, West & Central India",
          groups: [
            { state: "Goa", cities: [] },
            { state: "Gujarat", cities: ["Ahmedabad", "Bhuj", "Dwarka", "Gir", "Patan", "Kevadiya", "Narmada Tent City", "Rann of Kutch", "Somnath"] },
            { state: "Madhya Pradesh", cities: ["Bhedaghat", "Bhopal", "Gwalior", "Indore", "Jabalpur", "Khajuraho", "Omkareshwar", "Orchha", "Maheshwar", "Mandu", "Pachmarhi", "Sanchi", "Ujjain"] },
            { state: "Maharashtra", cities: [] },
            { state: "Rajasthan", cities: ["Bikaner", "Chittorgarh", "Jaipur", "Jaisalmer", "Jodhpur", "Jowai", "Kumbhalgarh", "Mandawa", "Mount Abu", "Pushkar", "Ranthambore", "Udaipur"] },
          ],
        },
      ],
    },
  },
  {
    label: "World",
    route: "/world",
    mega: {
      kind: "destinations",
      video: {
        title: "World in 4K",
        youtubeId: "rTDaZoDDW5g",
        thumbnail: "/assets/media/009-images-unsplash-com-photo-1499856871958-5b9627545d1a.jpg",
      },
      feature: {
        title: "Royal Europe",
        subtitle: "12 Days · ₹1,69,000",
        image: "/assets/media/014-images-unsplash-com-photo-1502602898657-3e91760cbb34.jpg",
      },
      topRow: ["Europe", "South East Asia", "Australia New Zealand", "America", "Africa", "Japan China Korea Taiwan"],
      regions: [
        {
          name: "Africa",
          groups: [
            { state: "All of Africa", cities: [] },
            { state: "Egypt", cities: ["Alexandria", "Aswan", "Cairo", "Luxor", "Nile Cruise"] },
            { state: "Kenya", cities: ["Masai Mara"] },
            { state: "Mauritius", cities: ["Port Louis"] },
            { state: "South Africa", cities: ["Cape Town", "George", "Mossel Bay", "Pilanesberg National Park", "Port Elizabeth (Gqeberha)", "Sun City"] },
            { state: "Zimbabwe", cities: ["Victoria Falls"] },
          ],
        },
        {
          name: "America",
          groups: [
            { state: "All of America", cities: [] },
            { state: "All of South America", cities: [] },
            { state: "Argentina", cities: [] },
            { state: "Brazil", cities: ["Rio De Janerio"] },
            { state: "Canada", cities: ["Banff", "Calgary", "Jasper", "Montreal", "Ottawa", "Toronto", "Vancouver"] },
            { state: "USA", cities: ["Chicago", "Las Vegas", "Los Angeles", "New York", "Niagara Falls", "Orlando", "Philadelphia", "San Francisco", "Washington"] },
          ],
        },
        {
          name: "Asia",
          groups: [
            { state: "All of South East Asia", cities: [] },
            { state: "All of Far East Asia", cities: [] },
            { state: "Bhutan", cities: [] },
            { state: "Nepal", cities: ["Chitwan", "Kathmandu", "Pokhara"] },
            { state: "Sri Lanka", cities: ["Bentota", "Colombo", "Galle", "Kandy", "Nuwara Eliya"] },
            { state: "Maldives", cities: [] },
            { state: "Cambodia", cities: [] },
            { state: "Singapore", cities: [] },
            { state: "Malaysia", cities: ["Kuala Lumpur", "Genting Highlands", "Langkawi"] },
            { state: "Indonesia", cities: ["Bali", "Kuta", "Nusa Penida", "Ubud"] },
            { state: "Hong Kong", cities: [] },
            { state: "Macao", cities: [] },
            { state: "China", cities: ["Beijing", "Shanghai", "Shenzhen"] },
            { state: "Taiwan", cities: [] },
            { state: "Vietnam", cities: ["Hanoi", "Ho Chi Minh"] },
            { state: "Myanmar", cities: [] },
            { state: "Laos", cities: [] },
            { state: "Thailand", cities: ["Bangkok", "Krabi", "Pattaya", "Phuket"] },
            { state: "Japan", cities: ["Cherry Blossom Tours", "Hiroshima", "Kyoto", "Osaka", "Tokyo"] },
            { state: "South Korea", cities: ["Seoul"] },
            { state: "Philippines", cities: [] },
          ],
        },
        {
          name: "Australia & New Zealand",
          groups: [
            { state: "Australia", cities: ["Adelaide", "Brisbane", "Cairns", "Canberra", "Gold Coast", "Great Barrier Reef", "Great Ocean Road", "Perth", "Western Australia", "Melbourne", "Sydney", "Queensland"] },
            { state: "Fiji", cities: [] },
            { state: "New Zealand", cities: ["Auckland", "Christchurch", "Rotorua", "Queenstown"] },
          ],
        },
        {
          name: "Europe",
          groups: [
            { state: "All of Europe", cities: [] },
            { state: "Western Europe", cities: ["Austria", "Belgium", "England", "France", "Germany", "Geneva", "Interlaken", "Ireland", "Italy", "Liechtenstein", "Luxembourg", "Netherlands", "Scotland", "Switzerland", "Paris", "Vatican city"] },
            { state: "Central & Eastern Europe", cities: ["Croatia", "Czech Republic", "Georgia", "Hungary", "Poland", "Slovenia", "Slovakia"] },
            { state: "Northern Europe", cities: ["Norway", "Sweden", "Denmark", "Finland", "Iceland", "Estonia", "Russia"] },
            { state: "Mediterranean Europe", cities: ["Azerbaijan", "Greece", "Turkey", "Spain", "Portugal", "Morocco", "Egypt", "Jordan", "Israel", "Uzbekistan", "Kazakhstan"] },
            { state: "Highlights", cities: ["Midnight Sun", "Northern Lights", "Scandinavia"] },
          ],
        },
        {
          name: "Middle East",
          groups: [
            { state: "Dubai · Abu Dhabi · Middle East", cities: [] },
            { state: "Israel", cities: [] },
            { state: "Jordan", cities: ["Petra"] },
            { state: "Oman", cities: ["Muscat"] },
            { state: "United Arab Emirates", cities: ["Abu Dhabi", "Dubai", "Ferrari World"] },
            { state: "Saudi Arabia", cities: [] },
            { state: "Qatar", cities: ["Doha"] },
          ],
        },
        {
          name: "Antarctica",
          groups: [
            { state: "Antarctica", cities: ["The 7th Continent"] },
          ],
        },
      ],
    },
  },
  {
    label: "Speciality Tours",
    route: "/category/speciality-tours",
    mega: {
      kind: "themes",
      eyebrow: "Speciality experiences — find your reason",
      items: [
        { icon: "Heart", label: "Honeymoon" },
        { icon: "Users", label: "Women Only" },
        { icon: "Compass", label: "Senior Citizens" },
        { icon: "Sparkles", label: "Solo Travel" },
        { icon: "Church", label: "Pilgrimage" },
        { icon: "Flower2", label: "Yoga & Wellness" },
        { icon: "Mountain", label: "Adventure" },
        { icon: "Camera", label: "Photo Tours" },
      ],
      features: [
        {
          title: "Honeymoon · Maldives",
          description: "Overwater villas, private sandbanks & sunset dhonis.",
          image: "/assets/media/017-images-unsplash-com-photo-1514282401047-d79a71a590e8.jpg",
        },
      ],
      video: {
        title: "Honeymoon Stories",
        youtubeId: "rTDaZoDDW5g",
        thumbnail: "/assets/media/023-images-unsplash-com-photo-1530841377377-3ff06c0ca713.jpg",
      },
    },
  },
  {
    label: "Customized Holidays",
    route: "/category/customized-holidays",
    mega: {
      kind: "themes",
      eyebrow: "Themed experiences — find your reason!",
      items: [
        { icon: "Briefcase", label: "Family Fun" },
        { icon: "Heart", label: "Romantic Holidays" },
        { icon: "Tent", label: "Getaways" },
        { icon: "CalendarCheck", label: "Fixed Date Holiday", badge: "Newly Launched" },
        { icon: "Car", label: "Self Drive Holidays" },
        { icon: "Ship", label: "Cruise Holidays" },
        { icon: "Map", label: "Hidden Gems" },
        { icon: "Plane", label: "Air Inclusive Holidays" },
      ],
      features: [
        {
          title: "Luxury Holidays",
          description: "Tailor-made luxury travel vacations curated to your taste.",
          image: "/assets/media/036-images-unsplash-com-photo-1582719508461-905c673771fd.jpg",
        },
      ],
      video: {
        title: "Island Getaways",
        youtubeId: "rTDaZoDDW5g",
        thumbnail: "/assets/media/035-images-unsplash-com-photo-1573843981267-be1999ff37cd.jpg",
      },
    },
  },
  {
    label: "Corporate Travel",
    route: "/category/corporate-travel",
    mega: {
      kind: "themes",
      eyebrow: "Corporate & MICE — built for boardrooms",
      items: [
        { icon: "Briefcase", label: "Corporate Off-sites" },
        { icon: "Users", label: "Team Building" },
        { icon: "CalendarCheck", label: "Conferences" },
        { icon: "Sparkles", label: "Incentive Trips" },
        { icon: "Plane", label: "Business Travel" },
        { icon: "Crown", label: "Executive Retreats" },
      ],
      features: [
        {
          title: "MICE Across India",
          description: "Goa · Jaipur · Bengaluru · Andaman board offsites.",
          image: "/assets/media/018-images-unsplash-com-photo-1522071820081-009f0129c71c.jpg",
        },
      ],
      video: {
        title: "Incentive · Bali",
        youtubeId: "rTDaZoDDW5g",
        thumbnail: "/assets/media/025-images-unsplash-com-photo-1537996194471-e657df975ab4.jpg",
      },
    },
  },
  {
    label: "Inbound",
    route: "/category/inbound",
    mega: {
      kind: "themes",
      eyebrow: "Welcoming the world to India",
      items: [
        { icon: "Crown", label: "Golden Triangle" },
        { icon: "Mountain", label: "Himalayan Odyssey" },
        { icon: "Palmtree", label: "South India" },
        { icon: "Leaf", label: "Wildlife & Nature" },
        { icon: "Landmark", label: "Heritage Tours" },
        { icon: "Sparkles", label: "Spiritual India" },
      ],
      features: [
        {
          title: "Royal Rajasthan",
          description: "Palace stays, desert nights & camel safaris.",
          image: "/assets/media/037-images-unsplash-com-photo-1599661046289-e31897846e41.jpg",
        },
      ],
      video: {
        title: "Kerala Backwaters",
        youtubeId: "rTDaZoDDW5g",
        thumbnail: "/assets/media/038-images-unsplash-com-photo-1602216056096-3b40cc0c9944.jpg",
      },
    },
  },
  {
    label: "Visa Services",
    route: "/category/visa-services",
    mega: {
      kind: "themes",
      eyebrow: "Visa assistance — 50+ countries",
      items: [
        { icon: "Plane", label: "Schengen Visa" },
        { icon: "Crown", label: "UK Visa" },
        { icon: "Sparkles", label: "USA Visa" },
        { icon: "Compass", label: "Canada Visa" },
        { icon: "Mountain", label: "Australia Visa" },
        { icon: "Landmark", label: "Dubai Visa" },
        { icon: "Map", label: "Japan Visa" },
        { icon: "Briefcase", label: "Business Visa" },
      ],
      features: [
        {
          title: "Schengen made simple",
          description: "Document checklist, slot booking & form filing in one go.",
          image: "/assets/media/004-images-unsplash-com-photo-1469854523086-cc02fe5d8800.jpg",
        },
      ],
      video: {
        title: "Express Visa Desk",
        youtubeId: "rTDaZoDDW5g",
        thumbnail: "/assets/media/005-images-unsplash-com-photo-1488646953014-85cb44e25828.jpg",
      },
    },
  },
];

export const COUNTRY_FLAGS = [
  { name: "India", code: "in" },
  { name: "United Arab Emirates", code: "ae" },
  { name: "Singapore", code: "sg" },
  { name: "Thailand", code: "th" },
  { name: "Japan", code: "jp" },
  { name: "South Korea", code: "kr" },
  { name: "Indonesia", code: "id" },
  { name: "Vietnam", code: "vn" },
  { name: "Maldives", code: "mv" },
  { name: "United Kingdom", code: "gb" },
  { name: "France", code: "fr" },
  { name: "Italy", code: "it" },
  { name: "Spain", code: "es" },
  { name: "Greece", code: "gr" },
  { name: "Switzerland", code: "ch" },
  { name: "Germany", code: "de" },
  { name: "Iceland", code: "is" },
  { name: "Norway", code: "no" },
  { name: "Turkey", code: "tr" },
  { name: "Egypt", code: "eg" },
  { name: "Kenya", code: "ke" },
  { name: "South Africa", code: "za" },
  { name: "United States", code: "us" },
  { name: "Canada", code: "ca" },
  { name: "Brazil", code: "br" },
  { name: "Australia", code: "au" },
  { name: "New Zealand", code: "nz" },
];

export const VALUE_PROPS = [
  { icon: "Trophy", title: "Best Europe", subtitle: "Tour Packages", href: "/world?q=Europe" },
  { icon: "Sun", title: "Seasonal", subtitle: "Summer", href: "/search?q=summer" },
  { icon: "Tag", title: "Deals", subtitle: "Unbeatable", href: "/search?deals=1" },
];

export const HERO_SLIDES = [
  {
    type: "image",
    eyebrow: "Discover the world",
    headline: "Travel, the",
    headlineAccent: "Royal way.",
    description:
      "Bespoke holidays across India and around the world — quietly curated since March 2010.",
    price: null,
    priceSuffix: null,
    ctaLabel: "Explore tours",
    image:
      "/assets/media/013-images-unsplash-com-photo-1502602898657-3e91760cbb34.jpg",
  },
  {
    type: "image",
    eyebrow: "All-inclusive tours starting at just",
    headline: "Europe with",
    headlineAccent: "Royal Tours!",
    description: "22 hand-crafted Europe itineraries · 60+ departures a year.",
    price: "₹1,69,000",
    priceSuffix: "/ per person on twin sharing",
    ctaLabel: "View Europe tours",
    image:
      "/assets/media/013-images-unsplash-com-photo-1502602898657-3e91760cbb34.jpg",
  },
  {
    type: "image",
    eyebrow: "Snow valleys · houseboats · spice coasts",
    headline: "Incredible",
    headlineAccent: "India.",
    description: "Kashmir, Kerala, Himachal, North East, Rajasthan & beyond.",
    price: "₹35,000",
    priceSuffix: "/ starting per person",
    ctaLabel: "Explore India",
    image:
      "/assets/media/030-images-unsplash-com-photo-1564507592333-c60657eea523.jpg",
  },
  {
    type: "image",
    eyebrow: "Dubai · Abu Dhabi · Oman",
    headline: "Arabian",
    headlineAccent: "Escapes.",
    description: "Desert safaris, sky-touching skylines and royal indulgence.",
    price: "₹62,000",
    priceSuffix: "/ per person on twin sharing",
    ctaLabel: "View Dubai tours",
    image:
      "/assets/media/049-images-unsplash-com-photo-1749849934727-bc57c0bd9dd2.jpg",
  },
  {
    type: "image",
    eyebrow: "Bali · Thailand · Singapore · Vietnam",
    headline: "Mystic",
    headlineAccent: "Far East.",
    description: "Temples, beaches and street-food trails across SE Asia.",
    price: "₹79,000",
    priceSuffix: "/ starting per person",
    ctaLabel: "View Asia tours",
    image:
      "/assets/media/015-images-unsplash-com-photo-1506665531195-3566af2b4dfa.jpg",
  },
  {
    type: "image",
    eyebrow: "Niagara · Vegas · Yellowstone · Disney",
    headline: "Americas",
    headlineAccent: "Unbound.",
    description: "Coast-to-coast wonder across the United States & Canada.",
    price: "₹2,40,000",
    priceSuffix: "/ per person on twin sharing",
    ctaLabel: "View USA tours",
    image:
      "/assets/media/028-images-unsplash-com-photo-1554208791-ff69f8454d1b.jpg",
  },
];


export const HERO_REGIONS = [
  {
    name: "Northern Europe",
    packages: "22 Packages",
    price: "₹1,75,000",
    icon: "/assets/media/012-images-unsplash-com-photo-1502602898657-3e91760cbb34.jpg",
  },
  {
    name: "Western Europe",
    packages: "98 Packages",
    price: "₹1,69,000",
    icon: "/assets/media/006-images-unsplash-com-photo-1499856871958-5b9627545d1a.jpg",
  },
  {
    name: "Central & Eastern Europe",
    packages: "22 Packages",
    price: "₹2,40,000",
    icon: "/assets/media/026-images-unsplash-com-photo-1541849546-216549ae216d.jpg",
  },
  {
    name: "Mediterranean Europe",
    packages: "53 Packages",
    price: "₹1,75,000",
    icon: "/assets/media/021-images-unsplash-com-photo-1530841377377-3ff06c0ca713.jpg",
  },
];

export const MOST_LOVED = [
  {
    title: "Best of Kashmir",
    from: "₹54,000",
    guests: "17.8k guests travelled",
    image: "/assets/media/048-images-unsplash-com-photo-1675185991531-9c2aee461355.jpg",
  },
  {
    title: "Highlights of Kerala",
    from: "₹35,000",
    guests: "10.6k guests travelled",
    image: "/assets/media/039-images-unsplash-com-photo-1602216056096-3b40cc0c9944.jpg",
  },
  {
    title: "Best of Andaman",
    from: "₹80,000",
    guests: "8k guests travelled",
    image: "/assets/media/051-images-unsplash-com-photo-1762254794468-1fb6fa893f73.jpg",
  },
  {
    title: "Shimla Manali",
    from: "₹62,000",
    guests: "9.2k guests travelled",
    image: "/assets/media/042-images-unsplash-com-photo-1626621341517-bbf3d9990a23.jpg",
  },
  {
    title: "Singapore Thailand Malaysia",
    from: "₹1,70,000",
    guests: "29k guests travelled",
    image: "/assets/media/019-images-unsplash-com-photo-1525625293386-3f8f99389edd.jpg",
  },
  {
    title: "Best of Thailand",
    from: "₹79,000",
    guests: "24.3k guests travelled",
    image: "/assets/media/016-images-unsplash-com-photo-1506665531195-3566af2b4dfa.jpg",
  },
  {
    title: "European Jewels with Versailles",
    from: "₹4,10,000",
    guests: "12.1k guests travelled",
    image: "/assets/media/010-images-unsplash-com-photo-1499856871958-5b9627545d1a.jpg",
  },
  {
    title: "Singapore Malaysia",
    from: "₹1,48,000",
    guests: "14.5k guests travelled",
    image: "/assets/media/033-images-unsplash-com-photo-1565967511849-76a60a516170.jpg",
  },
];

export const TRENDING = [
  {
    name: "Andaman",
    tours: "5 Tours",
    departures: "138 Departures",
    travelled: "29293 + Guests Travelled",
    image: "/assets/media/027-images-unsplash-com-photo-1547471080-7cc2caa01a7e.jpg",
  },
  {
    name: "Kashmir",
    tours: "20 Tours",
    departures: "265 Departures",
    travelled: "131281 + Guests Travelled",
    image: "/assets/media/048-images-unsplash-com-photo-1675185991531-9c2aee461355.jpg",
  },
  {
    name: "Himachal",
    tours: "18 Tours",
    departures: "317 Departures",
    travelled: "217396 + Guests Travelled",
    image: "/assets/media/042-images-unsplash-com-photo-1626621341517-bbf3d9990a23.jpg",
  },
  {
    name: "North East",
    tours: "6 Tours",
    departures: "103 Departures",
    travelled: "5963 + Guests Travelled",
    image: "/assets/media/042-images-unsplash-com-photo-1626621341517-bbf3d9990a23.jpg",
  },
  {
    name: "Sikkim Darjeeling",
    tours: "6 Tours",
    departures: "103 Departures",
    travelled: "30507 + Guests Travelled",
    image: "/assets/media/042-images-unsplash-com-photo-1626621341517-bbf3d9990a23.jpg",
  },
  {
    name: "Leh Ladakh",
    tours: "8 Tours",
    departures: "118 Departures",
    travelled: "23279 + Guests Travelled",
    image: "/assets/media/045-images-unsplash-com-photo-1645033393637-9089ab100756.jpg",
  },
  {
    name: "Africa",
    tours: "8 Tours",
    departures: "20 Departures",
    travelled: "3653 + Guests Travelled",
    image: "/assets/media/027-images-unsplash-com-photo-1547471080-7cc2caa01a7e.jpg",
  },
  {
    name: "America",
    tours: "13 Tours",
    departures: "56 Departures",
    travelled: "18652 + Guests Travelled",
    image: "/assets/media/029-images-unsplash-com-photo-1554208791-ff69f8454d1b.jpg",
  },
  {
    name: "Dubai and MiddleEast",
    tours: "8 Tours",
    departures: "148 Departures",
    travelled: "47610 + Guests Travelled",
    image: "/assets/media/050-images-unsplash-com-photo-1749849934727-bc57c0bd9dd2.jpg",
  },
  {
    name: "Nepal",
    tours: "4 Tours",
    departures: "43 Departures",
    travelled: "12482 + Guests Travelled",
    image: "/assets/media/040-images-unsplash-com-photo-1605640840605-14ac1855827b.jpg",
  },
  {
    name: "South East Asia",
    tours: "34 Tours",
    departures: "277 Departures",
    travelled: "227049 + Guests Travelled",
    image: "/assets/media/016-images-unsplash-com-photo-1506665531195-3566af2b4dfa.jpg",
  },
  {
    name: "Europe",
    tours: "38 Tours",
    departures: "277 Departures",
    travelled: "124629 + Guests Travelled",
    image: "/assets/media/010-images-unsplash-com-photo-1499856871958-5b9627545d1a.jpg",
  },
];

export const FEATURE_SLIDES = [
  {
    region: "North East",
    title: "Best Of Arunachal",
    route: "Guwahati · Tezpur · Bomdila · Tawang · Dirang · Itanagar · Ziro",
    days: "9 Days",
    date: "29 May",
    from: "Ex-Mumbai",
    price: "₹1,05,000",
    joining: "Joining Leaving price from ₹86,000",
    image: "/assets/media/041-images-unsplash-com-photo-1626621341517-bbf3d9990a23.jpg",
  },
  {
    region: "Europe",
    title: "European Jewels with Versailles",
    route: "Paris · Versailles · Brussels · Amsterdam · Lucerne · Rome",
    days: "12 Days",
    date: "18 June",
    from: "Ex-Delhi",
    price: "₹4,10,000",
    joining: "Joining Leaving price from ₹3,75,000",
    image: "/assets/media/007-images-unsplash-com-photo-1499856871958-5b9627545d1a.jpg",
  },
  {
    region: "Middle East",
    title: "Royal Dubai Escape",
    route: "Dubai · Abu Dhabi · Sharjah · Desert Safari",
    days: "6 Days",
    date: "12 July",
    from: "Ex-Mumbai",
    price: "₹89,000",
    joining: "Joining Leaving price from ₹72,000",
    image: "/assets/media/049-images-unsplash-com-photo-1749849934727-bc57c0bd9dd2.jpg",
  },
];

export const ACTIVITIES = [
  { icon: "Mountain", title: "Adventure", count: "15 Destination" },
  { icon: "Footprints", title: "Trekking", count: "12 Destinations" },
  { icon: "Flame", title: "Camp Fire", count: "7 Destination" },
  { icon: "Signpost", title: "Off Road", count: "15 Destination" },
  { icon: "Tent", title: "Camping", count: "13 Destination" },
  { icon: "Map", title: "Exploring", count: "25 Destination" },
];

export const ASSOCIATIONS = [
  "TAAI", "TAFI", "ADTOI", "OTOAI", "ATOAI", "IATA", "NIDHI", "TTAUP",
  "MSME", "Ministry of Tourism · Govt of India",
  "Dept. of Tourism · Govt of Uttar Pradesh",
];

export const ASSOCIATION_LOGOS = [
  { acronym: "TAAI", name: "Travel Agents Association of India", type: "image", image: "/assets/media/associations/taai.jpg" },
  { acronym: "TAFI", name: "Travel Agents Federation of India", type: "image", image: "/assets/media/associations/tafi.jpg" },
  { acronym: "ADTOI", name: "Association of Domestic Tour Operators of India", type: "image", image: "/assets/media/associations/adtoi.jpg" },
  { acronym: "OTOAI", name: "Outbound Tour Operators Association of India", type: "image", image: "/assets/media/associations/otoai.jpg" },
  { acronym: "ATOAI", name: "Adventure Tour Operators Association of India", type: "image", image: "/assets/media/associations/atoai.jpg" },
  { acronym: "IATA", name: "International Air Transport Association", type: "image", image: "/assets/media/associations/iata.jpg" },
  { acronym: "NIDHI", name: "National Integrated Database of Hospitality Industry", type: "image", image: "/assets/media/associations/nidhi.jpg" },
  { acronym: "TTAUP", name: "Travel Trade Association of Uttar Pradesh", type: "image", image: "/assets/media/associations/ttaup.jpg" },
  { acronym: "MSME", name: "Ministry of Micro, Small & Medium Enterprises", type: "image", image: "/assets/media/associations/msme.jpg" },
  { acronym: "Incredible India", name: "Ministry of Tourism · Govt of India", type: "image", image: "/assets/media/associations/ministry-of-tourism.jpg" },
  { acronym: "UP Tourism", name: "Department of Tourism · Govt of Uttar Pradesh", type: "image", image: "/assets/media/associations/uttar-pradesh-tourism.jpg" },
];

export const SUMMER_DESTINATIONS = [
  {
    name: "Kashmir",
    country: "India",
    months: "Apr – Jul",
    blurb: "Tulip gardens, shikara rides on Dal & alpine meadows in bloom.",
    price: "₹54,000",
    image:
      "/assets/media/046-images-unsplash-com-photo-1675185991531-9c2aee461355.jpg",
  },
  {
    name: "Leh · Ladakh",
    country: "India",
    months: "May – Sep",
    blurb: "Moonscapes, monasteries and Pangong's electric blues.",
    price: "₹78,000",
    image:
      "/assets/media/043-images-unsplash-com-photo-1645033393637-9089ab100756.jpg",
  },
  {
    name: "Switzerland",
    country: "Europe",
    months: "Jun – Aug",
    blurb: "Glacier trains, alpine lakes, cheese trails & Jungfrau peaks.",
    price: "₹2,15,000",
    image:
      "/assets/media/020-images-unsplash-com-photo-1530841377377-3ff06c0ca713.jpg",
  },
  {
    name: "Finland",
    country: "Nordic",
    months: "Jun – Aug",
    blurb: "Midnight sun over Lapland forests, lakes and Helsinki harbours.",
    price: "₹2,80,000",
    image:
      "/assets/media/011-images-unsplash-com-photo-1500382017468-9049fed747ef.jpg",
  },
  {
    name: "Bali",
    country: "Indonesia",
    months: "Apr – Sep",
    blurb: "Rice terraces, cliff-top temples and dreamy beach clubs.",
    price: "₹89,000",
    image:
      "/assets/media/024-images-unsplash-com-photo-1537996194471-e657df975ab4.jpg",
  },
  {
    name: "Santorini",
    country: "Greece",
    months: "May – Sep",
    blurb: "Whitewashed villages, caldera sunsets and Aegean wine.",
    price: "₹1,95,000",
    image:
      "/assets/media/034-images-unsplash-com-photo-1570077188670-e3a8d69ac5ff.jpg",
  },
];

export const FAQS = [
  {
    q: "Where can I find information about Royal Tours Group tours and products?",
    a: "Royal Tours Group's website royaltoursgroup.in contains information about all our products, tour categories and services. You can also call our Toll Free number 1800 266 1100 and get all the details about tours and various products from Royal Tours travel advisors.",
  },
  {
    q: "What type of tours or packages does Royal Tours Group offer?",
    a: "We offer Group Tours, Customized Holidays, Speciality Tours (honeymoon, women-only, pilgrimage, senior citizens), Corporate & MICE, Inbound India tours and Visa services across India and 60+ countries.",
  },
  {
    q: "Does Royal Tours Group book train tickets?",
    a: "Yes — train tickets are arranged as part of our tour packages where rail travel is part of the itinerary. Standalone rail bookings are available on request through our travel desk.",
  },
  {
    q: "Where can I find the addresses of Royal Tours Group offices or its Sales Partners?",
    a: "Our Head Office is at Golghar, Gorakhpur, Uttar Pradesh. For a complete list of branch offices and authorised Sales Partners across India, please call 1800 266 1100 or email holiday@royaltoursgroup.in.",
  },
  {
    q: "How many travellers will be there as a part of a group tour?",
    a: "Our small-group escorted tours typically range between 18 and 35 guests, ensuring a personal experience while keeping the camaraderie of a group. MICE and bespoke groups are sized to the booking.",
  },
];

export const FOOTER_COLUMNS = {
  mainLinks: [
    "Home",
    "Group Tours",
    "Tours At a Glance",
    "All Group Tours",
    "Speciality Tours",
    "Economy Tours",
    "Experiences",
    "Corporate Travel",
    "Asia",
    "Forex & Insurance",
    "Royal Academy",
  ],
  guestServices: [
    "Guest Corner",
    "How to Book",
    "Tour Leaders",
    "Online Payment",
    "Guest Feedback",
    "Testimonials",
    "Privacy Policy",
    "Terms & Condition",
  ],
  partner: [
    "Join as PSA",
    "Join as GSA",
    "Franchisee",
    "Franchisee/PSA Online",
    "Travel Agent",
    "Careers",
  ],
  company: ["About Us", "Videos", "Blog"],
};

export const EBROCHURES = [
  {
    title: "Himalayan",
    image: "/assets/media/044-images-unsplash-com-photo-1645033393637-9089ab100756.jpg",
  },
  {
    title: "The Princess",
    image: "/assets/media/022-images-unsplash-com-photo-1530841377377-3ff06c0ca713.jpg",
  },
  {
    title: "Think Travel · Think Royal",
    image: "/assets/media/008-images-unsplash-com-photo-1499856871958-5b9627545d1a.jpg",
  },
  {
    title: "Bharat Darshan",
    image: "/assets/media/031-images-unsplash-com-photo-1564507592333-c60657eea523.jpg",
  },
];
